import { render, staticRenderFns } from "./ReadPrivacyNews.vue?vue&type=template&id=0aa884a0"
import script from "./ReadPrivacyNews.vue?vue&type=script&lang=js"
export * from "./ReadPrivacyNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports